// Copyright (c) 2016 Deere & Company

import productRegistrationActions from './product-registration/actions-list';
import sharedActions from '../shared/actions-list';

export default Object.freeze({
    ...sharedActions,
    ...productRegistrationActions,
    CLOSE_DEALER_RECOMMENDATION_MODAL: 'CLOSE_DEALER_RECOMMENDATION_MODAL',
    CREATE_NEW_TRANSFER_SUCCESS: 'CREATE_NEW_TRANSFER_SUCCESS',
    CREATE_PRODUCT_DETAILS_COMPONENTS: 'CREATE_PRODUCT_DETAILS_COMPONENTS',
    DELETE_DUPLICATE_PIN_PLATE_FILE: 'DELETE_DUPLICATE_PIN_PLATE_FILE',
    DELETE_FILE_SUCCESS: 'DELETE_FILE_SUCCESS',
    DELETE_PRODUCT_DETAILS_COMPONENTS: 'DELETE_PRODUCT_DETAILS_COMPONENTS',
    DELETE_REGISTRATION_SUCCESS: 'DELETE_REGISTRATION_SUCCESS',
    FILTER_PRODUCT_SEARCH_RESULTS: 'FILTER_PRODUCT_SEARCH_RESULTS',
    GET_DEALER_RECOMMENDATIONS: 'GET_DEALER_RECOMMENDATIONS',
    GET_HIGH_RENTAL_DAYS_PIN: 'GET_HIGH_RENTAL_DAYS_PIN',
    OPEN_DEALER_RECOMMENDATION_MODAL: 'OPEN_DEALER_RECOMMENDATION_MODAL',
    READ_MEASUREMENT_READINGS_SUCCESS: 'READ_MEASUREMENT_READINGS_SUCCESS',
    READ_PRIMARY_PRODUCT_STATUSES_SUCCESS: 'READ_PRIMARY_PRODUCT_STATUSES_SUCCESS',
    READ_PRODUCT_DETAILS_CUSTOMER_SUCCESS: 'READ_PRODUCT_DETAILS_CUSTOMER_SUCCESS',
    READ_PRODUCT_DETAILS_ERROR: 'READ_PRODUCT_DETAILS_ERROR',
    READ_PRODUCT_SEARCH_CUSTOMER_SUCCESS: 'READ_PRODUCT_SEARCH_CUSTOMER_SUCCESS',
    READ_STATES_IN_COUNTRY_SUCCESS: 'READ_STATES_IN_COUNTRY_SUCCESS',
    RESET_ACCOUNT_LOOKUP: 'RESET_ACCOUNT_LOOKUP',
    RESET_DEALER_SEARCH_PARAMS: 'RESET_DEALER_SEARCH_PARAMS',
    RESET_DEALER_SEARCH_RESULTS: 'RESET_DEALER_SEARCH_RESULTS',
    RESET_DUPLICATE_PIN_PLATE: 'RESET_DUPLICATE_PIN_PLATE',
    RESET_DUPLICATE_PIN_PLATE_FORM_VALIDATION: 'RESET_DUPLICATE_PIN_PLATE_FORM_VALIDATION',
    RESET_NEW_REGISTRATION_FORM_VALIDATION: 'RESET_NEW_REGISTRATION_FORM_VALIDATION',
    RESET_NEW_TRANSFER: 'RESET_NEW_TRANSFER',
    RESET_PRODUCT_CUSTOMER_DETAILS: 'RESET_PRODUCT_CUSTOMER_DETAILS',
    RESET_PRODUCT_DETAILS_COMPONENT_TO_ADD: 'RESET_PRODUCT_DETAILS_COMPONENT_TO_ADD',
    RESET_PRODUCT_DETAILS_CREATE_CLAIM_MODAL: 'RESET_PRODUCT_DETAILS_CREATE_CLAIM_MODAL',
    RESET_PRODUCT_DETAILS_OPTION_TO_ADD: 'RESET_PRODUCT_DETAILS_OPTION_TO_ADD',
    RESET_PRODUCT_DETAILS_PURCHASE_ORDER: 'RESET_PRODUCT_DETAILS_PURCHASE_ORDER',
    RESET_PRODUCT_DETAILS_STATE: 'RESET_PRODUCT_DETAILS_STATE',
    RESET_PRODUCT_SEARCH_FACETS: 'RESET_PRODUCT_SEARCH_FACETS',
    RESET_REGISTRATION_FACETS: 'RESET_REGISTRATION_FACETS',
    RESET_REGISTRATION_PRODUCT: 'RESET_REGISTRATION_PRODUCT',
    RESET_SELECTED_DEALER_RECOMMENDATIONS: 'RESET_SELECTED_DEALER_RECOMMENDATIONS',
    RESET_STATUS_CHANGE_REQUEST_STATE: 'RESET_STATUS_CHANGE_REQUEST_STATE',
    RESET_TRANSFER_APPROVAL_FACETS: 'RESET_TRANSFER_APPROVAL_FACETS',
    RESET_TRANSFER_RECOMMENDATION_FACETS: 'RESET_TRANSFER_RECOMMENDATION_FACETS',
    SET_CSC2_RECORD_DETAILS: 'SET_CSC2_RECORD_DETAILS',
    SET_PRODUCT_SEARCH_STATUS_FACET: 'SET_PRODUCT_SEARCH_STATUS_FACET',
    SET_SEARCH_RESULT_CLAIM_TYPES: 'SET_SEARCH_RESULT_CLAIM_TYPES',
    SET_TRANSFER_REJECTED_REASON: 'SET_TRANSFER_REJECTED_REASON',
    TOGGLE_PRODUCT_DETAILS_ACCORDION: 'TOGGLE_PRODUCT_DETAILS_ACCORDION',
    TOGGLE_PRODUCT_DETAILS_ACCORDIONS: 'TOGGLE_PRODUCT_DETAILS_ACCORDIONS',
    TOGGLE_PRODUCT_REPORTS_ACCORDION: 'TOGGLE_PRODUCT_REPORTS_ACCORDION',
    TOGGLE_PRODUCT_SEARCH_DEALER_FACET_ITEMS: 'TOGGLE_PRODUCT_SEARCH_DEALER_FACET_ITEMS',
    TOGGLE_PRODUCT_SEARCH_STATUS_FACET_ITEMS: 'TOGGLE_PRODUCT_SEARCH_STATUS_FACET_ITEMS',
    TOGGLE_SEARCH_RESULT_CREATE_CLAIM_MODAL: 'TOGGLE_SEARCH_RESULT_CREATE_CLAIM_MODAL',
    TOGGLE_TRANSFER_APPROVAL_FACET_ITEMS: 'TOGGLE_TRANSFER_APPROVAL_FACET_ITEMS',
    TOGGLE_TRANSFER_RECOMMENDATION_FACET_ITEMS: 'TOGGLE_TRANSFER_RECOMMENDATION_FACET_ITEMS',
    UPDATE_ACCOUNT_LOOKUP: 'UPDATE_ACCOUNT_LOOKUP',
    UPDATE_BASE_MACHINE_IMPLEMENTS_FILE: 'UPDATE_BASE_MACHINE_IMPLEMENTS_FILE',
    UPDATE_CUSTOMER_SEARCH_MODAL_VISIBILITY: 'UPDATE_CUSTOMER_SEARCH_MODAL_VISIBILITY',
    UPDATE_DEALER_SEARCH_DIVISION_PARAMS: 'UPDATE_DEALER_SEARCH_DIVISION_PARAMS',
    UPDATE_DEALER_SEARCH_MODAL_VISIBILITY: 'UPDATE_DEALER_SEARCH_MODAL_VISIBILITY',
    UPDATE_DEALER_SEARCH_PARAMS: 'UPDATE_DEALER_SEARCH_PARAMS',
    UPDATE_DEALER_SEARCH_RESULTS_SUCCESS: 'UPDATE_DEALER_SEARCH_RESULTS_SUCCESS',
    UPDATE_DELIVERY_FACETS_DATE_RANGE: 'UPDATE_DELIVERY_FACETS_DATE_RANGE',
    UPDATE_DETAILS_ERROR: 'UPDATE_DETAILS_ERROR',
    UPDATE_DETAILS_SUCCESS: 'UPDATE_DETAILS_SUCCESS',
    UPDATE_DIVISION_SUCCESS: 'UPDATE_DIVISION_SUCCESS',
    UPDATE_DUPLICATE_PIN_PLATE_ADDRESS1: 'UPDATE_DUPLICATE_PIN_PLATE_ADDRESS1',
    UPDATE_DUPLICATE_PIN_PLATE_ADDRESS2: 'UPDATE_DUPLICATE_PIN_PLATE_ADDRESS2',
    UPDATE_DUPLICATE_PIN_PLATE_CITY: 'UPDATE_DUPLICATE_PIN_PLATE_CITY',
    UPDATE_DUPLICATE_PIN_PLATE_COUNTRY: 'UPDATE_DUPLICATE_PIN_PLATE_COUNTRY',
    UPDATE_DUPLICATE_PIN_PLATE_DEALER_LOCATION: 'UPDATE_DUPLICATE_PIN_PLATE_DEALER_LOCATION',
    UPDATE_DUPLICATE_PIN_PLATE_FILE: 'UPDATE_DUPLICATE_PIN_PLATE_FILE',
    UPDATE_DUPLICATE_PIN_PLATE_FORM_VALIDATION: 'UPDATE_DUPLICATE_PIN_PLATE_FORM_VALIDATION',
    UPDATE_DUPLICATE_PIN_PLATE_INFORMATION: 'UPDATE_DUPLICATE_PIN_PLATE_INFORMATION',
    UPDATE_DUPLICATE_PIN_PLATE_INSTRUCTIONS: 'UPDATE_DUPLICATE_PIN_PLATE_INSTRUCTIONS',
    UPDATE_DUPLICATE_PIN_PLATE_MACHINE_MODEL: 'UPDATE_DUPLICATE_PIN_PLATE_MACHINE_MODEL',
    UPDATE_DUPLICATE_PIN_PLATE_MAILING_RECIPIENT: 'UPDATE_DUPLICATE_PIN_PLATE_MAILING_RECIPIENT',
    UPDATE_DUPLICATE_PIN_PLATE_MISSING_PLATE_REASON: 'UPDATE_DUPLICATE_PIN_PLATE_MISSING_PLATE_REASON',
    UPDATE_DUPLICATE_PIN_PLATE_PHONE: 'UPDATE_DUPLICATE_PIN_PLATE_PHONE',
    UPDATE_DUPLICATE_PIN_PLATE_PIN: 'UPDATE_DUPLICATE_PIN_PLATE_PIN',
    UPDATE_DUPLICATE_PIN_PLATE_REQUESTER_TCSM: 'UPDATE_DUPLICATE_PIN_PLATE_REQUESTER_TCSM',
    UPDATE_DUPLICATE_PIN_PLATE_STATE: 'UPDATE_DUPLICATE_PIN_PLATE_STATE',
    UPDATE_DUPLICATE_PIN_PLATE_TEMPORARY_OBJECT_KEY: 'UPDATE_DUPLICATE_PIN_PLATE_TEMPORARY_OBJECT_KEY',
    UPDATE_DUPLICATE_PIN_PLATE_ZIP_CODE: 'UPDATE_DUPLICATE_PIN_PLATE_ZIP_CODE',
    UPDATE_FACTORY_PIN_PLATE_RESULTS: 'UPDATE_FACTORY_PIN_PLATE_RESULTS',
    UPDATE_FACTORY_PIN_PLATE_SELECTED_ITEMS: 'UPDATE_FACTORY_PIN_PLATE_SELECTED_ITEMS',
    UPDATE_HAS_SEARCH_RESULTS: 'UPDATE_HAS_SEARCH_RESULTS',
    UPDATE_INCENTIVE_PROGRAMS_SUCCESS: 'UPDATE_INCENTIVE_PROGRAMS_SUCCESS',
    UPDATE_MODAL_STATE: 'UPDATE_MODAL_STATE',
    UPDATE_NEW_REGISTRATION_AMOUNT_OF_USE_MODAL_VISIBILITY: 'UPDATE_NEW_REGISTRATION_AMOUNT_OF_USE_MODAL_VISIBILITY',
    UPDATE_NEW_REGISTRATION_DOMAIN_VALUES: 'UPDATE_NEW_REGISTRATION_DOMAIN_VALUES',
    UPDATE_NEW_REGISTRATION_FORM_VALIDATION: 'UPDATE_NEW_REGISTRATION_FORM_VALIDATION',
    UPDATE_NEW_REGISTRATION_MODALS: 'UPDATE_NEW_REGISTRATION_MODALS',
    UPDATE_NEW_REGISTRATION_PRINT_REGISTRATION_MODAL: 'UPDATE_NEW_REGISTRATION_PRINT_REGISTRATION_MODAL',
    UPDATE_NEW_REGISTRATION_PROPERTY: 'UPDATE_NEW_REGISTRATION_PROPERTY',
    UPDATE_NEW_TRANSFER_AMOUNT_OF_USE_MODAL_VISIBILITY: 'UPDATE_NEW_TRANSFER_AMOUNT_OF_USE_MODAL_VISIBILITY',
    UPDATE_NEW_TRANSFER_NEW_DEALER: 'UPDATE_NEW_TRANSFER_NEW_DEALER',
    UPDATE_NEW_TRANSFER_PRODUCT_SUCCESS: 'UPDATE_NEW_TRANSFER_PRODUCT_SUCCESS',
    UPDATE_NEW_TRANSFER_STATUS_CHANGE_MODAL: 'UPDATE_NEW_TRANSFER_STATUS_CHANGE_MODAL',
    UPDATE_NEW_TRANSFER_SUCCESS: 'UPDATE_NEW_TRANSFER_SUCCESS',
    UPDATE_OPTION_CODES_SUCCESS: 'UPDATE_OPTION_CODES_SUCCESS',
    UPDATE_PIN_PLATE_REQUEST: 'UPDATE_PIN_PLATE_REQUEST',
    UPDATE_PIPS_SUCCESS: 'UPDATE_PIPS_SUCCESS',
    UPDATE_PRODUCT_CLAIMS_SUCCESS: 'UPDATE_PRODUCT_CLAIMS_SUCCESS',
    UPDATE_PRODUCT_COMPONENTS_SUCCESS: 'UPDATE_PRODUCT_COMPONENTS_SUCCESS',
    UPDATE_PRODUCT_DETAILS_AMOUNT_OF_USE_MODAL_VISIBILITY: 'UPDATE_PRODUCT_DETAILS_AMOUNT_OF_USE_MODAL_VISIBILITY',
    UPDATE_PRODUCT_DETAILS_CLAIM_TYPES: 'UPDATE_PRODUCT_DETAILS_CLAIM_TYPES',
    UPDATE_PRODUCT_DETAILS_COMPONENTS: 'UPDATE_PRODUCT_DETAILS_COMPONENTS',
    UPDATE_PRODUCT_DETAILS_COMPONENT_CODES: 'UPDATE_PRODUCT_DETAILS_COMPONENT_CODES',
    UPDATE_PRODUCT_DETAILS_COMPONENT_TO_ADD: 'UPDATE_PRODUCT_DETAILS_COMPONENT_TO_ADD',
    UPDATE_PRODUCT_DETAILS_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_PRODUCT_DETAILS_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_PRODUCT_DETAILS_EDIT_AMOUNT_OF_USE_MODAL_VISIBILITY: 'UPDATE_PRODUCT_DETAILS_EDIT_AMOUNT_OF_USE_MODAL_VISIBILITY',
    UPDATE_PRODUCT_DETAILS_EXTERNAL_NOTES: 'UPDATE_PRODUCT_DETAILS_EXTERNAL_NOTES',
    UPDATE_PRODUCT_DETAILS_OPTION_TO_ADD: 'UPDATE_PRODUCT_DETAILS_OPTION_TO_ADD',
    UPDATE_PRODUCT_DETAILS_PRODUCT_SUCCESS: 'UPDATE_PRODUCT_DETAILS_PRODUCT_SUCCESS',
    UPDATE_PRODUCT_DETAILS_PURCHASE_ORDER: 'UPDATE_PRODUCT_DETAILS_PURCHASE_ORDER',
    UPDATE_PRODUCT_DETAILS_SHOW_ADD_COMPONENT_ROW: 'UPDATE_PRODUCT_DETAILS_SHOW_ADD_COMPONENT_ROW',
    UPDATE_PRODUCT_DETAILS_STATUS_CHANGE_MODAL: 'UPDATE_PRODUCT_DETAILS_STATUS_CHANGE_MODAL',
    UPDATE_PRODUCT_DUPLICATE_PIN_PLATE: 'UPDATE_PRODUCT_DUPLICATE_PIN_PLATE',
    UPDATE_PRODUCT_IMPLEMENTS_SUCCESS: 'UPDATE_PRODUCT_IMPLEMENTS_SUCCESS',
    UPDATE_PRODUCT_MACHINE_STATUS_UPDATES: 'UPDATE_PRODUCT_MACHINE_STATUS_UPDATES',
    UPDATE_PRODUCT_MAINTENANCE_PLANS_SUCCESS: 'UPDATE_PRODUCT_MAINTENANCE_PLANS_SUCCESS',
    UPDATE_PRODUCT_SEARCH_BY: 'UPDATE_PRODUCT_SEARCH_BY',
    UPDATE_PRODUCT_SEARCH_CUSTOMER_CKC_ID: 'UPDATE_PRODUCT_SEARCH_CUSTOMER_CKC_ID',
    UPDATE_PRODUCT_SEARCH_CUSTOMER_ID: 'UPDATE_PRODUCT_SEARCH_CUSTOMER_ID',
    UPDATE_PRODUCT_SEARCH_CUSTOMER_MODAL_VISIBILITY: 'UPDATE_PRODUCT_SEARCH_CUSTOMER_MODAL_VISIBILITY',
    UPDATE_PRODUCT_SEARCH_DEALER_FACET_INPUT: 'UPDATE_PRODUCT_SEARCH_DEALER_FACET_INPUT',
    UPDATE_PRODUCT_SEARCH_DEALER_FACET_ITEM: 'UPDATE_PRODUCT_SEARCH_DEALER_FACET_ITEM',
    UPDATE_PRODUCT_SEARCH_DEALER_FACET_ON_LOAD: 'UPDATE_PRODUCT_SEARCH_DEALER_FACET_ON_LOAD',
    UPDATE_PRODUCT_SEARCH_PRODUCT: 'UPDATE_PRODUCT_SEARCH_PRODUCT',
    UPDATE_PRODUCT_SEARCH_QUERY_STRING: 'UPDATE_PRODUCT_SEARCH_QUERY_STRING',
    UPDATE_PRODUCT_SEARCH_STATUS_CHANGE_MODAL_VISIBILITY: 'UPDATE_PRODUCT_SEARCH_STATUS_CHANGE_MODAL_VISIBILITY',
    UPDATE_PRODUCT_SEARCH_STATUS_FACET_ITEM: 'UPDATE_PRODUCT_SEARCH_STATUS_FACET_ITEM',
    UPDATE_PRODUCT_WARRANTIES_SUCCESS: 'UPDATE_PRODUCT_WARRANTIES_SUCCESS',
    UPDATE_QUERY: 'UPDATE_QUERY',
    UPDATE_REASON_FOR_CHANGE: 'UPDATE_REASON_FOR_CHANGE',
    UPDATE_RECOMMENDATION_COMMENT_SUCCESS: 'UPDATE_RECOMMENDATION_COMMENT_SUCCESS',
    UPDATE_REGISTERED_DATE_RANGE_FACET: 'UPDATE_REGISTERED_DATE_RANGE_FACET',
    UPDATE_REGISTRATION_DEALER_ACCOUNT_FACET_INPUT: 'UPDATE_REGISTRATION_DEALER_ACCOUNT_FACET_INPUT',
    UPDATE_REGISTRATION_FACETS_DATE_RANGE: 'UPDATE_REGISTRATION_FACETS_DATE_RANGE',
    UPDATE_REGISTRATION_FACET_ITEMS_ON_LOAD: 'UPDATE_REGISTRATION_FACET_ITEMS_ON_LOAD',
    UPDATE_REGISTRATION_HISTORY_SUCCESS: 'UPDATE_REGISTRATION_HISTORY_SUCCESS',
    UPDATE_REGISTRATION_RESULTS: 'UPDATE_REGISTRATION_RESULTS',
    UPDATE_REGISTRATION_SUCCESS: 'UPDATE_REGISTRATION_SUCCESS',
    UPDATE_REQUESTED_DATE_RANGE_FACET: 'UPDATE_REQUESTED_DATE_RANGE_FACET',
    UPDATE_SEARCH_RESULTS_SUCCESS: 'UPDATE_SEARCH_RESULTS_SUCCESS',
    UPDATE_SELECTED_ALL_DEALER_RECOMMENDATIONS: 'UPDATE_SELECTED_ALL_DEALER_RECOMMENDATIONS',
    UPDATE_SELECTED_DEALER_RECOMMENDATIONS: 'UPDATE_SELECTED_DEALER_RECOMMENDATIONS',
    UPDATE_STATUS_CHANGE_COUNTRIES_SUCCESS: 'UPDATE_STATUS_CHANGE_COUNTRIES_SUCCESS',
    UPDATE_STATUS_CHANGE_PRODUCT_SUCCESS: 'UPDATE_STATUS_CHANGE_PRODUCT_SUCCESS',
    UPDATE_STATUS_CHANGE_REQUEST_FORM: 'UPDATE_STATUS_CHANGE_REQUEST_FORM',
    UPDATE_STATUS_CHANGE_REQUEST_OBJECT: 'UPDATE_STATUS_CHANGE_REQUEST_OBJECT',
    UPDATE_STATUS_CHANGE_REQUEST_OBJECT_FILE_LIST: 'UPDATE_STATUS_CHANGE_REQUEST_OBJECT_FILE_LIST',
    UPDATE_STATUS_CHANGE_REQUEST_PRODUCT_DETAILS: 'UPDATE_STATUS_CHANGE_REQUEST_PRODUCT_DETAILS',
    UPDATE_STATUS_CHANGE_SELECTED_MACHINE_PUT_BACK: 'UPDATE_STATUS_CHANGE_SELECTED_MACHINE_PUT_BACK',
    UPDATE_TEMP_PRODUCT_IMPLEMENTS_PURCHASE_ORDER: 'UPDATE_TEMP_PRODUCT_IMPLEMENTS_PURCHASE_ORDER',
    UPDATE_TRANSFER_APPROVAL_FACET_INPUT: 'UPDATE_TRANSFER_APPROVAL_FACET_INPUT',
    UPDATE_TRANSFER_APPROVAL_FACET_ITEM: 'UPDATE_TRANSFER_APPROVAL_FACET_ITEM',
    UPDATE_TRANSFER_APPROVAL_FACET_ITEMS_ON_LOAD: 'UPDATE_TRANSFER_APPROVAL_FACET_ITEMS_ON_LOAD',
    UPDATE_TRANSFER_COMMENT_SUCCESS: 'UPDATE_TRANSFER_COMMENT_SUCCESS',
    UPDATE_TRANSFER_RECOMMENDATION_FACET_INPUT: 'UPDATE_TRANSFER_RECOMMENDATION_FACET_INPUT',
    UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEM: 'UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEM',
    UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEMS_ON_LOAD: 'UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEMS_ON_LOAD',
    UPDATE_TRANSFER_REJECTED_REASON: 'UPDATE_TRANSFER_REJECTED_REASON',
    UPDATE_TRANSFER_RESULTS: 'UPDATE_TRANSFER_RESULTS',
    UPDATE_TRANSFER_STATUS_SUCCESS: 'UPDATE_TRANSFER_STATUS_SUCCESS'
});



// WEBPACK FOOTER //
// ./src/product/actions-list.js